
export default function load(loader) {
    const _reuseSameArguments = (func) => {
        const argMap = new Map();
    
        return (...args) => {
            const key = JSON.stringify(args);
            if (argMap.has(key)) return argMap.get(key);
            
            const result = func(...args);
            argMap.set(key, result);
            return result;
        }
    }
    
    loader.module('require_script', function _module__require_script() {
        return (function require_script(script_path, essential) {
            // if (essential === false && !window.OptOutConfig.is_activated()) {
            //     return WidgetAPI.promise(function(_, reject){reject('3rd-party library loading blocked.')});
            // }
    
            return WidgetAPI.promise(function(resolve, reject) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.onload = resolve;
                script.src = script_path;
                document.getElementsByTagName('head')[0].appendChild(script);
            });
        });
    });
    
    loader.module('require_css', function _module__require_css() {
        return (function require_css(css_path, essential) {
            if (essential === false && !window.OptOutConfig.is_activated()) {
                return WidgetAPI.promise(function(_, reject){reject('3rd-party css loading blocked.')});
            }
            return WidgetAPI.promise(function(resolve, reject) {
                var link = document.createElement('link');
                link.type = "text/css";
                link.rel = "stylesheet";
                link.href = css_path;
                link.onload = resolve;
                document.getElementsByTagName('head')[0].appendChild(link);
            });
        });
    });
    
    loader.noop = function(name, value) {
        loader.module(name, [], function __module_require_dynamic(){return value;});
        return name;
    };
    
    (function(){
        var _static_id = 0;
        loader.static = function(value) {
            var name = "@static:" + _static_id;
            _static_id = _static_id +  1;
            loader.module(name, [], async function __module_require_dynamic() {
                const { scriptEval } = await import("@/utils/scripts.ts");
                return await scriptEval(value);
            }, true);
            return name;
        }
    
        loader.registerPreprocessor("static", (_, args) => {
            return loader.static(args);
        });
    })();
    
    loader.alias = function(old_name, new_name) {
        loader.module(new_name, [old_name], function __module_require_dynamic(v) {
            return v;
        });
        return new_name;
    };
    
    loader.object = function(exposed, name, requirements) {
        if (!name)
            name = "@object:" + exposed;
    
        if (!requirements)
            requirements = [];
        
        loader.module(name, requirements, function __module_require_dynamic() {
             return window[exposed_name];
        });
    
        return name;
    };
    
    (function(){
        loader.url_endpoint = _reuseSameArguments(function(arg) {
            const name = "@url:" + JSON.stringify(arg);
            loader.module(name, [], async function __module_require_dynamic() {
                let value = arg;
                if (typeof arg === "string") {
                    const {scriptEval} = await import("@/utils/scripts");
                    value = await scriptEval(`return ${arg}`);
                }
                const { resolve_url } = await import("./require_script_http");
                return resolve_url(value);
            }, true);
            return name;
        });
        
        loader.registerPreprocessor("endpoint", (_, args) => {
            return loader.url_endpoint(args);
        });
    })();
    
    loader.load = function(a) {
        var _load_name = loader.url_endpoint.apply(null, [a])
        var name = "@load:" + _load_name;
        loader.module(name, [_load_name], async function __module_require_ajax(url) {
            const { default: client } = await import("@/utils/http");
            return (await client.get(url)).data;
        }, true);
        
        return name;
    };
    loader.registerPreprocessor("load", (_, args) => {
        return loader.load(args);
    });
    
    
    (function(){
        let has_permission_url = null;
        loader.permission = function(permission) {
            var name = "@permission:" + permission;
            loader.module(name, [], async function() {
                const [{ default: client }, {resolve_url}] = await Promise.all([import("@/utils/http"), import("./require_script_http")])
                if (has_permission_url === null)
                    has_permission_url = resolve_url({controller: "permissions", action: "check"})
                return (await client.get(await has_permission_url, {params: {activity: permission}})).data.result;
            }, true);
            return name;
        };
        loader.registerPreprocessor("permission", (_, args) => {
            return loader.permission(args);
        });
    })();

    loader.registerPreprocessor("task", (_, args) => {
        const name = `@task:${args}`;
        loader.module(name, [], async () => {
            return async (...params) => {
                const { getBrowserTask } = await import("@/utils/tasks");
                await getBrowserTask(args)(...params)
            }
        });
        return name;
    });
    
    loader.js = function(url, exposed_name) {
        var name = "@js:" + url;
        loader.module(name, ['require_script'], function __module_require_dynamic(require_script){
            if (window[exposed_name] !== undefined) return Promise.resolve(window[exposed_name]);
            return require_script(url).then(function() {
                if (exposed_name !== undefined)
                    return window[exposed_name];
            });
        });
        return name;
    };
    
    loader.css = function(url) {
        var name = "@css:" + url;
        loader.module(name, ['require_css'], function __module_require_dynamic(require_css){
            return require_css(url);
        });
        return name;
    };

    
    (function() {
        loader.frontend = _reuseSameArguments(function(requested_name) {
            var name = "@frontend:" + requested_name;
            loader.module(name, ['frontend'], async function __module_require_dynamic(webshop) {
                const controller = new AbortController();
                async function waitThisLoaded(name) {
                    console.log("[Loader] Waiting for " + name + " in @frontend loader.");
                    await loader.when_declared(name, "<~webshop>", controller.signal);
                    return name;
                }

                try {
                    requested_name = await waitThisLoaded(requested_name);
                } catch (e) {
                    controller.abort();
                }

                return await loader.require(requested_name);
            }, true);
            return name;
        });
    
        loader.registerPreprocessor("webshop", (_, args) => {
            return loader.frontend(args);
        });
    })();
    
    loader.alias('underscore', '_');
    
    loader.noop('bootstrap');
    loader.noop('font-awesome');
};

